import { render, staticRenderFns } from "./list-po-fail.vue?vue&type=template&id=481fa03b&"
import script from "./list-po-fail.vue?vue&type=script&lang=js&"
export * from "./list-po-fail.vue?vue&type=script&lang=js&"
import style0 from "./list-po-fail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports